import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import BasicFormInput from '../form/BasicFormInput';
import BlitzAPI from '../../api/BlitzAPI';

class TagForm extends Component {
  constructor(props) {
    super(props);
    this.onDeleteClick = this.onDeleteClick.bind(this);
  }

  onDeleteClick() {
    const { tagId } = this.props;
    if (confirm('Delete this tag?')) {
      BlitzAPI.deleteTag(tagId).then(
        () => browserHistory.push('/tags'),
      );
    }
  }

  render() {
    const { handleSubmit, onSubmit, tagId } = this.props;

    return (
      <form onSubmit={handleSubmit(onSubmit)}>
        <Field
          type="text"
          name="name"
          placeholder="Tag Name"
          component={BasicFormInput}
          controlId="tagName"
          label="Tag Name"
        />
        <Field
          component={BasicFormInput}
          placeholder="Priority"
          type="number"
          name="priority"
          label="Priority (Lower is higher priority)"
          controlId="priority"
        />
        <Button type="submit">Submit</Button>
        {
          tagId ?
            <Button
              type="button"
              bsStyle="danger"
              className="pull-right"
              onClick={this.onDeleteClick}
            >Delete</Button> : null
        }
      </form>
    );
  }
}

const selector = formValueSelector('tag');
function mapStateToProps(state) {
  return {
    tagId: selector(state, 'id'),
  };
}

TagForm = connect(
  mapStateToProps,
)(reduxForm({ form: 'tag', enableReinitialize: true })(TagForm));

TagForm.propTypes = {
  handleSubmit: PropTypes.func,
  onSubmit: PropTypes.func,
  tagId: PropTypes.number,
};

export default TagForm;



// WEBPACK FOOTER //
// ./src/cms/tag/TagForm.js